<template>
  <div>
    <el-form>
      <el-form-item>
        <el-switch
          v-model="proxyConfig.mode"
          style="display: block"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="开启代理"
          inactive-text="关闭代理"
          active-value="true"
          inactive-value="false"
        />
      </el-form-item>
      <el-divider content-position="left">源地址</el-divider>
      <el-form :inline="true">
        <el-form-item label="API地址">
          <el-input v-model="proxyConfig.apiUrl" style="width: 400px;" placeholder="API地址" />
        </el-form-item>
        <el-form-item label="WS地址">
          <el-input v-model="proxyConfig.wsUrl" style="width: 400px;" placeholder="WS地址" />
        </el-form-item>
        <el-form-item label="新WS地址">
          <el-input v-model="proxyConfig.wsNewUrl" style="width: 400px;" placeholder="新WS地址" />
        </el-form-item>
      </el-form>
      <el-divider content-position="left">代理地址</el-divider>
      <el-form :inline="true">
        <el-form-item label="API地址">
          <el-input v-model="proxyConfig.proxyApiUrl" style="width: 400px;" placeholder="API地址" />
        </el-form-item>
        <el-form-item label="WS地址">
          <el-input v-model="proxyConfig.proxyWsUrl" style="width: 400px;" placeholder="WS地址" />
        </el-form-item>
        <el-form-item label="新WS地址">
          <el-input v-model="proxyConfig.proxyWsNewUrl" style="width: 400px;" placeholder="新WS地址" />
        </el-form-item>
      </el-form>
      <el-form-item>
        <el-button v-permisaction="['config:staticConfig:add']" type="primary" @click="onSubmit">保存</el-button>
        <el-button v-permisaction="['config:staticConfig:add']" style="margin-left: 10px" type="primary" @click="makeJson()">更新代理配置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getProxyCfg, makeStaticJson, updateProxyCfg } from '@/api/config/staticcfg'

export default {
  name: 'ProxyCfg',
  data() {
    return {
      proxyConfig: {
        mode: '',
        apiUrl: '',
        wsNewUrl: '',
        wsUrl: '',
        proxyApiUrl: '',
        proxyWsUrl: '',
        proxyWsNewUrl: ''
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getProxyCfg().then(res => {
        if (res.code === 200) {
          if (res.data.data !== null) {
            this.proxyConfig = res.data.data
            this.mode = this.proxyConfig.type === true ? true : 1
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      if (!this.proxyConfig.apiUrl) {
        this.msgError('原地址-api地址不能为空')
        return
      }
      if (!this.proxyConfig.wsUrl) {
        this.msgError('原地址-WS地址不能为空')
        return
      }
      if (!this.proxyConfig.proxyApiUrl) {
        this.msgError('代理地址-api不能为空')
        return
      }
      if (!this.proxyConfig.proxyWsUrl) {
        this.msgError('代理地址-WS地址不能为空')
        return
      }
      const data = JSON.stringify(this.proxyConfig)
      updateProxyCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.getTables()
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    makeJson() {
      makeStaticJson().then(res => {
        if (res.code === 200) {
          this.msgSuccess('更新成功')
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
